import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti laden';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_AUSFUEHREN = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti ausführen';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_ERFOLGREICH = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti laden erfolgreich';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_FEHLER = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti Ladefehler';
export const POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti nicht ausgeführt (evtl. Offline)';


export class PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI;
        constructor(public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiAusfuehrenAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_AUSFUEHREN;
        constructor(public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiErfolgreichAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.FunktionsbereichIdentifier, public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiFehlerAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_FEHLER;
        constructor(public payload: any, public rolleMultiRequest: api.RolleMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiActions =
    PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiAction
    | PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiAusfuehrenAction
    | PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiErfolgreichAction
    | PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiFehlerAction
    | PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiNichtAusgefuehrtAction
    ;
